<mat-sidenav-container class="sidenav-container">
  <mat-sidenav #drawer class="sidenav" fixedInViewport
      [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
      [mode]="(isHandset$ | async) ? 'over' : 'side'"
      [opened]="(isHandset$ | async) === false">
    <mat-toolbar>Menu</mat-toolbar>
    <mat-nav-list>
      <a mat-list-item href="/lateral-control">Lateral Control</a>
      <a mat-list-item (click)="notImplementedMessage()">Longitudinal Control</a>
      <a mat-list-item href="/two-intersections">Two intersections</a>
      <a mat-list-item href="/highway-two-lanes">Highway (2 lanes)</a>
    </mat-nav-list>
  </mat-sidenav>
  <mat-sidenav-content>
    <mat-toolbar color="primary">
      <button
        type="button"
        aria-label="Toggle sidenav"
        mat-icon-button
        (click)="drawer.toggle()"
        *ngIf="isHandset$ | async">
        <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
      </button>
      <span>Live Simulations - Alexandre Lombard</span>
      <span class="fill-remaining-space"></span>
      <span style="margin: auto;">
        <a
          target="_blank"
          href="https://www.ciad-lab.fr">
        <img
          width="40"
          alt="Ciad Lab Logo"
          src="../../assets/logo_ciad_40.png" />
      </a>
      </span>
    </mat-toolbar>
    <!-- Add Content Here -->
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>
